import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

import PanelVueEnsemble from "./panels/PanelVueEnsemble";
import PanelActivite from "./panels/PanelActivite";
import PanelTresorerie from "./panels/PanelTresorerie";
import PanelFinancement from "./panels/PanelFinancement";
import PanelSocial from "./panels/PanelSocial";
import PanelEtat from "./panels/PanelEtat";

const TABS = [
  { key: "vue_ensemble", label: "Vue d'ensemble" },
  { key: "activite", label: "Activité" },
  { key: "tresorerie", label: "Trésorerie" },
  { key: "financement", label: "Financement" },
  { key: "social", label: "Social" },
  { key: "etat", label: "État" },
];

const PANEL_COMPONENTS = {
  vue_ensemble: PanelVueEnsemble,
  activite: PanelActivite,
  tresorerie: PanelTresorerie,
  financement: PanelFinancement,
  social: PanelSocial,
  etat: PanelEtat,
};

const CrmDashboard = ({
  indicators,
  result,
  isDirty,
  setIsDirty,
  editableResult,
  setEditableResult,
}) => {
  const [activeTab, setActiveTab] = useState("vue_ensemble");

  const ActivePanel = PANEL_COMPONENTS[activeTab];

  return (
    <div className="space-y-4">
      {/* TABS */}
      <div className="flex gap-1 bg-gray-100 p-1 rounded-lg overflow-x-auto">
        {TABS.map((tab) => {
          const isActive = tab.key === activeTab;

          return (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className="flex-1 min-w-fit whitespace-nowrap text-xs font-semibold px-3 py-2 rounded-md transition-all"
              style={{
                backgroundColor: isActive ? "#7E1738" : "transparent",
                color: isActive ? "#fff" : "#6B7280",
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* PANEL */}
      <AnimatePresence mode="wait">
        <motion.div
          key={activeTab}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.15 }}
          className="bg-white rounded-lg border shadow-sm p-5"
        >
          <ActivePanel
            indicators={indicators}
            result={result}
            isDirty={isDirty}
            setIsDirty={setIsDirty}
            editableResult={editableResult}
            setEditableResult={setEditableResult}
          />
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default CrmDashboard;
